import clsx from 'clsx';
import { ComponentProps } from 'react';

import { Link } from '../Link';

import { Button } from './index';

export function IconButton({
  to,
  params,
  disabled,
  className,
  children,
  title = '',
  color = 'default',
  'data-cy': dataCy,
  ...props
}: ComponentProps<typeof Button> & ComponentProps<typeof Link>) {
  return (
    <Button
      title={title}
      color={color}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      className={clsx(className, 'btn-icon !md-0')}
      disabled={disabled}
      as={disabled ? 'span' : Link}
      props={{
        to,
        params,
      }}
      data-cy={dataCy}
    >
      {children}
    </Button>
  );
}
